export default "/_nuxt/c59b341a3a24b5e5399d00a0f187a33d.svg";